import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "anticheat",
  "use": "anticheat-usage",
  "viewBox": "0 0 12 16",
  "content": "<symbol viewBox=\"0 0 12 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"anticheat\">\n    <path d=\"M2.084 13.602c.88.867 3.702 2.301 3.822 2.362l.07.036.073-.034c.02-.01 2.109-1.002 3.478-2.065C11.191 12.609 12 11.43 12 10.294V2.07L5.97 0 0 2.071v8.345c0 1.045 1.076 2.192 2.084 3.186zm3.822.371c-.08-.045-1.945-1.121-2.528-1.772l-.24-.264C2.551 11.293 2 10.69 2 10V3.5L5.948 2v11.997l-.042-.024z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol